import {
    RaikoSectionContainer,
    RaikoBaseCardContainer,
    RaikoMaterialOutlinedInput,
    showErrorMessage,
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoFlexFirstChildGrowOne,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    showSuccessMessage,
} from "@moeindal/base-raiko-panel-components"

import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import TabContext from "@mui/lab/TabContext";
import TabBoxContainer from "../../component/tabBoxContainer/TabBoxContainer";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import {SettingService} from "../../serverService/settingService/SettingService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import SettingLoanTypes from "./SettingLoanTypes";

export default function Setting() {
    const service = new SettingService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [tabValue, setTabValue] = useState(SettingDetailTabTypes.Parameters.id);
    const [alphaParameters, setAlphaParameters] = useState("");
    const [buttonLoading, setButtonLoading] = useState(false)

    function handleChangeTab(event, newValue) {
        setTabValue(newValue)
    }

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getAlphaParametersFromServer()
        }
    }, []);

    function getAlphaParametersFromServer() {
        loading.show()
        service.getAlphaValue().then(
            response => {
                setAlphaParameters(response.multiplyLoanAmount)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function updateAlphaParameters() {
        setButtonLoading(true)
        service.updateAlphaParameters(alphaParameters).then(
            response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setButtonLoading(false)
        })
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.Setting.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={
                                [raikoBreadCrumbItemGenerator(
                                    RouteHelper.Setting.name,
                                    RouteHelper.Setting.url
                                )
                                ]
                            }
                        />
                    </RaikoFlexFirstChildGrowOne>
                    <TabContext value={tabValue}>
                        <TabBoxContainer>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab
                                    label={SettingDetailTabTypes.Parameters.title}
                                    value={SettingDetailTabTypes.Parameters.id}/>
                                <Tab
                                    label={SettingDetailTabTypes.LoanTable.title}
                                    value={SettingDetailTabTypes.LoanTable.id}/>
                            </TabList>
                        </TabBoxContainer>
                        <TabPanel value={SettingDetailTabTypes.Parameters.id}>
                            <RaikoGridOneColumn>
                                <RaikoBaseCardContainer>
                                    <RaikoSectionContainer
                                        title={"ضریب آلفا"}
                                        hasActionButton={true}
                                        actionButtonTitle={"بروزرسانی"}
                                        actionButtonLoadingState={buttonLoading}
                                        actionButtonOnclick={updateAlphaParameters}
                                    >
                                        <RaikoMaterialOutlinedInput
                                            labelText={"ضریب آلفا"}
                                            value={alphaParameters}
                                            setValue={setAlphaParameters}
                                        />

                                    </RaikoSectionContainer>
                                </RaikoBaseCardContainer>

                            </RaikoGridOneColumn>

                        </TabPanel>
                        <TabPanel value={SettingDetailTabTypes.LoanTable.id}>
                            <SettingLoanTypes/>
                        </TabPanel>

                    </TabContext>

                </RaikoGridOneColumn>

            </RaikoBaseContainer>
        </>
    )
}
const SettingDetailTabTypes = {
    Parameters: {
        id: "parameters",
        title: "پارامترها"
    },
    LoanTable: {
        id: "loan-table",
        title: "انواع وام"
    },
}